import { Application, AppRole, AuthState, getAuth, State } from '@cemex/cmx-client-layout';
import { ActionReducer, createSelector, MetaReducer } from '@ngrx/store';
/**
 * storeFreeze prevents state from being mutated. When mutation occurs, an
 * exception will be thrown. This is useful during development mode to
 * ensure that none of the reducers accidentally mutates the state.
 */

import { environment } from '../../../environments/environment';

// console.log all actions
export function logger(reducer: ActionReducer<State>): ActionReducer<State> {
  return function (state: State, action: any): State {
    return reducer(state, action);
  };
}

/**
 * By default, @ngrx/store uses combineReducers with the reducer map to compose
 * the root meta-reducer. To add more meta-reducers, provide an array of meta-reducers
 * that will be composed to form the root meta-reducer.
 */
export const metaReducers: MetaReducer<State>[] = !environment.production ? [logger] : [];

export const getUserCountry = createSelector(getAuth, (auth) => {
  return auth?.country;
});

export const getUserApplications = createSelector<State, [AuthState], Application[]>(getAuth, (auth) => {
  if (!auth) {
    return [];
  }
  if (!auth.applications) {
    return [];
  }
  return auth.applications;
});
export const getUserRoles = createSelector<State, [Application[]], AppRole[]>(getUserApplications, (apps) => {
  if (!apps) {
    return [];
  }
  return apps.reduce((acc, app) => [...acc, ...app.roles], []) || [];
});

export const findRole = (roleCode: string) => (role: AppRole) => role.roleCode === roleCode;

export const getUserRolesAll = createSelector<State, [Application[]], { [roleCode: string]: AppRole }>(
  getUserApplications,
  (apps) => {
    if (!apps) {
      return [];
    }

    return apps.reduce((acc, app) => {
      if (app.roles) {
        return {
          ...acc,
          ...app.roles.reduce((roles, role) => {
            return {
              ...roles,
              [role.roleCode]: role,
            };
          }, {}),
        };
      }

      return acc;
    }, {});
  },
);
